<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">Dashboard</li>
        <li class="breadcrumb-item active" aria-current="page">Monitor de transacciones</li>
      </ol>
    </nav>

    <div class="container-fluid">
      <vx-card class="mb-5">
        <div class="vx-row">
          <h1 class="vx-col w-full bold big-title m-0">Monitor de <span>Transacciones</span>.</h1>
        </div>
        <hr/>
        <div class="vx-row mb-4 text-center">
          <h6 class="vx-col w-full bold">
            Selecciona el tipo de filtrado:
          </h6>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col w-1/2">
            <vs-radio class="vx-col w-full" v-model.number="filterType" vs-value="1">Por día</vs-radio>
            <vs-radio class="vx-col w-full" v-model.number="filterType" vs-value="2">Por mes</vs-radio>
          </div>
          <div class="vx-col w-1/2">
            <label class="vs-input--label">Fecha de originación *</label>
            <datepicker
                class="w-full"
                v-model="date"
                :disabledDates="disabledDates"
                :language="es"
                format="dd/MM/yyyy"
                placeholder="Requerido"/>
          </div>
        </div>
        <hr>
        <div class="vx-row">
          <vs-button class="vx-col w-full my-4 mx-4" @click="handleSearch">Buscar</vs-button>
        </div>
      </vx-card>
      <vx-card class="mb-5">
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-table stripe noDataText="">
              <template slot="thead">
                <th class="header text-center">TRX</th>
                <th class="header text-right">Solicitantes</th>
                <th class="header text-center">Cantidad</th>
                <th class="header text-center">VS</th>
                <th class="header text-center">Cantidad</th>
                <th class="header text-left">Inversionistas</th>
                <th class="header text-center">TRX</th>
              </template>
              <tbody v-if="trxList">
              <!-- Start Dispersiones -->
              <vs-tr>
                <vs-td colspan="7" class="text-center bold bg-gray">
                  Dispersiones
                </vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td class="text-center">C220</vs-td>
                <vs-td class="text-left">Intereses proyecto %projects.alias% (ID:%projects.id%)</vs-td>
                <vs-td class="text-right">{{ getAmount('C220') }}</vs-td>
                <vs-td></vs-td>
                <vs-td class="text-right">{{ getAmount('I120') }}</vs-td>
                <vs-td class="text-left">Intereses proyecto %projects.alias% (ID:%projects.id%)</vs-td>
                <vs-td class="text-center">I120</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td class="text-center">C221</vs-td>
                <vs-td class="text-left">Intereses moratorios proyecto %projects.alias% (ID:%projects.id%)</vs-td>
                <vs-td class="text-right">{{ getAmount('C221') }}</vs-td>
                <vs-td></vs-td>
                <vs-td class="text-right">{{ getAmount('I121') }}</vs-td>
                <vs-td class="text-left">Intereses moratorios proyecto %projects.alias% (ID:%projects.id%)</vs-td>
                <vs-td class="text-center">I121</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td class="text-center">C230</vs-td>
                <vs-td class="text-left">Amortización proyecto %projects.alias% (ID:%projects.id%)</vs-td>
                <vs-td class="text-right">{{ getAmount('C230') }}</vs-td>
                <vs-td></vs-td>
                <vs-td class="text-right">{{ getAmount('I130') }}</vs-td>
                <vs-td class="text-left">Amortización proyecto %projects.alias% (ID:%projects.id%)</vs-td>
                <vs-td class="text-center">I130</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td class="text-center">C240</vs-td>
                <vs-td class="text-left">Penalizaciones proyecto %projects.alias% (ID:%projects.id%)</vs-td>
                <vs-td class="text-right">{{ getAmount('C240') }}</vs-td>
                <vs-td></vs-td>
                <vs-td class="text-right">{{ getAmount('I140') }}</vs-td>
                <vs-td class="text-left">Penalizaciones proyecto %projects.alias% (ID:%projects.id%)</vs-td>
                <vs-td class="text-center">I140</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td class="text-center">C290</vs-td>
                <vs-td class="text-left">IVA de intereses proyecto %projects.alias% (ID:%projects.id%)</vs-td>
                <vs-td class="text-right">{{ getAmount('C290') }}</vs-td>
                <vs-td></vs-td>
                <vs-td class="text-right">{{ getAmount('I190') }}</vs-td>
                <vs-td class="text-left">IVA de intereses proyecto %projects.alias% (ID:%projects.id%)</vs-td>
                <vs-td class="text-center">I190</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td class="text-center">C291</vs-td>
                <vs-td class="text-left">IVA de interés moratorio proyecto %projects.alias% (ID:%projects.id%)</vs-td>
                <vs-td class="text-right">{{ getAmount('C291') }}</vs-td>
                <vs-td></vs-td>
                <vs-td class="text-right">{{ getAmount('I191') }}</vs-td>
                <vs-td class="text-left">IVA de interés moratorio proyecto %projects.alias% (ID:%projects.id%)</vs-td>
                <vs-td class="text-center">I191</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td class="text-center">C254</vs-td>
                <vs-td class="text-left">Recuperación de proyecto %projects.alias% (ID:%projects.id%)</vs-td>
                <vs-td class="text-right">{{ getAmount('C254') }}</vs-td>
                <vs-td></vs-td>
                <vs-td class="text-right">{{ getAmount('I154') }}</vs-td>
                <vs-td class="text-left">Recuperación de proyecto %projects.alias% (ID:%projects.id%)</vs-td>
                <vs-td class="text-center">I154</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td></vs-td>
                <vs-td></vs-td>
                <vs-td class="text-right bold">
                  {{ getSum('dispersiones-solicitantes', 'C220', 'C221', 'C230', 'C240', 'C290', 'C291', 'C254') }}
                </vs-td>
                <vs-td></vs-td>
                <vs-td class="text-right bold">
                  {{ getSum('dispersiones-inversionistas', 'I120', 'I121', 'I130', 'I140', 'I190', 'I191', 'I154') }}
                </vs-td>
                <vs-td></vs-td>
                <vs-td></vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td></vs-td>
                <vs-td></vs-td>
                <vs-td class="text-right"
                       v-bind:class="{ 'text-danger': isGreaterThanZero('dispersiones-solicitantes', 'dispersiones-inversionistas') }">
                  {{ getDifference('dispersiones-solicitantes', 'dispersiones-inversionistas') }}
                </vs-td>
                <vs-td class="text-left">Diferencia</vs-td>
                <vs-td></vs-td>
                <vs-td></vs-td>
                <vs-td></vs-td>
              </vs-tr>
              <!-- End Dispersiones -->
              <!-- Start Inversión en Proyectos -->
              <vs-tr>
                <vs-td colspan="7" class="header text-center bold bg-gray">
                  Inversión en Proyectos
                </vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td class="text-center">C170</vs-td>
                <vs-td class="text-left">Crédito de proyecto %projects.alias% (ID:%projects.id%)</vs-td>
                <vs-td class="text-right">{{ getAmount('C170') }}</vs-td>
                <vs-td></vs-td>
                <vs-td class="text-right">{{ getAmount('I220') }}</vs-td>
                <vs-td class="text-left">Inversión directa en proyecto %projects.alias% (ID:%projects.id%)</vs-td>
                <vs-td class="text-center">I220</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td class="text-center"></vs-td>
                <vs-td class="text-right"></vs-td>
                <vs-td class="text-center"></vs-td>
                <vs-td></vs-td>
                <vs-td class="text-right">{{ getAmount('I221') }}</vs-td>
                <vs-td class="text-left">Inversión recurrente (riego por goteo) proyecto %projects.alias%
                  (ID:%projects.id%)
                </vs-td>
                <vs-td class="text-center">I221</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td></vs-td>
                <vs-td></vs-td>
                <vs-td class="text-center bold">{{ getSum('inversiones-en-proyectos-solicitantes', 'C170') }}</vs-td>
                <vs-td></vs-td>
                <vs-td class="text-center bold">
                  {{ getSum('inversiones-en-proyectos-inversionistas', 'I220', 'I221') }}
                </vs-td>
                <vs-td></vs-td>
                <vs-td></vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td></vs-td>
                <vs-td></vs-td>
                <vs-td class="text-center"
                       v-bind:class="{ 'text-danger': isGreaterThanZero('inversiones-en-proyectos-solicitantes', 'inversiones-en-proyectos-inversionistas') }">
                  {{ getDifference('inversiones-en-proyectos-solicitantes', 'inversiones-en-proyectos-inversionistas') }}
                </vs-td>
                <vs-td class="text-left">Diferencia</vs-td>
                <vs-td></vs-td>
                <vs-td></vs-td>
                <vs-td></vs-td>
              </vs-tr>
              <!-- End Inversión en Proyectos -->
              <!-- Start Inversión en Proyectos - Depósitos -->
              <vs-tr>
                <vs-td colspan="3" class="text-center bold">
                  Depósitos
                </vs-td>
                <vs-td colspan="7" class="text-center bold">
                  Depósitos
                </vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td class="text-center">C110</vs-td>
                <vs-td class="text-left">Abono por transferencia bancaria nacional</vs-td>
                <vs-td class="text-right">{{ getAmount('C110') }}</vs-td>
                <vs-td></vs-td>
                <vs-td class="text-right">{{ getAmount('I110') }}</vs-td>
                <vs-td class="text-left">Abono por transferencia bancaria</vs-td>
                <vs-td class="text-center">I110</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td class="text-center">C111</vs-td>
                <vs-td class="text-left">Abono por tarjeta con terminación %cards.card_number%</vs-td>
                <vs-td class="text-right">{{ getAmount('C111') }}</vs-td>
                <vs-td></vs-td>
                <vs-td class="text-right">{{ getAmount('I111') }}</vs-td>
                <vs-td class="text-left">Abono por tarjeta con terminación %card.card_number%</vs-td>
                <vs-td class="text-center">I111</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td class="text-center">C112</vs-td>
                <vs-td class="text-left">Bono por retraso de proyecto %projects.alias% (ID:%projects.id%)</vs-td>
                <vs-td class="text-right">{{ getAmount('C112') }}</vs-td>
                <vs-td></vs-td>
                <vs-td class="text-right">{{ getAmount('I112') }}</vs-td>
                <vs-td class="text-left">Abono recurrente (riego automático) por tarjeta con terminación
                  %card.card_number%
                </vs-td>
                <vs-td class="text-center">I112</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td class="text-center">C113</vs-td>
                <vs-td class="text-left">Abono por corresponsal</vs-td>
                <vs-td class="text-right">{{ getAmount('C113') }}</vs-td>
                <vs-td></vs-td>
                <vs-td class="text-right">{{ getAmount('I113') }}</vs-td>
                <vs-td class="text-left">Abono por corresponsal</vs-td>
                <vs-td class="text-center">I113</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td class="text-center">C114</vs-td>
                <vs-td class="text-left">Abono por domiciliación bancaria</vs-td>
                <vs-td class="text-right">{{ getAmount('C114') }}</vs-td>
                <vs-td></vs-td>
                <vs-td class="text-right">{{ getAmount('I114') }}</vs-td>
                <vs-td class="text-left">Abono por domiciliación bancaria</vs-td>
                <vs-td class="text-center">I114</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td class="text-center">C116</vs-td>
                <vs-td class="text-left">Abono por transferencia nacional en cuenta concentradora</vs-td>
                <vs-td class="text-right">{{ getAmount('C116') }}</vs-td>
                <vs-td></vs-td>
                <vs-td class="text-right">{{ getAmount('I116') }}</vs-td>
                <vs-td class="text-left">Abono por transferencia nacional en cuenta concentradora</vs-td>
                <vs-td class="text-center">I116</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td class="text-center">C117</vs-td>
                <vs-td class="text-left">Abono por transferencia internacional en cuenta concentradora</vs-td>
                <vs-td class="text-right">{{ getAmount('C117') }}</vs-td>
                <vs-td></vs-td>
                <vs-td class="text-right">{{ getAmount('I117') }}</vs-td>
                <vs-td class="text-left">Abono por transferencia internacional en cuenta concentradora</vs-td>
                <vs-td class="text-center">I117</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td class="text-center">C115</vs-td>
                <vs-td class="text-left">Abono por efectivo moneda nacional</vs-td>
                <vs-td class="text-right">{{ getAmount('C115') }}</vs-td>
                <vs-td></vs-td>
                <vs-td class="text-right">{{ getAmount('I151') }}</vs-td>
                <vs-td class="text-left">Reembolso de retiro no realizado</vs-td>
                <vs-td class="text-center">I151</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td></vs-td>
                <vs-td class="text-right bold">Total Depósitos</vs-td>
                <vs-td class="text-right bold">
                  {{ getSum('dispersiones-solicitantes', 'C110', 'C111', 'C112', 'C113', 'C114', 'C115', 'C116', 'C117') }}
                </vs-td>
                <vs-td></vs-td>
                <vs-td class="text-right bold">
                  {{ getSum('dispersiones-inversionistas', 'I110', 'I111', 'I112', 'I113', 'I114', 'I116', 'I117', 'I151') }}
                </vs-td>
                <vs-td class="text-left bold">Total Depósitos</vs-td>
                <vs-td></vs-td>
              </vs-tr>
              <!-- End Inversión en Proyectos - Depósitos -->
              <!-- Start Inversión en Proyectos - Retiros -->
              <vs-tr>
                <vs-td colspan="3" class="text-center bold">
                  Retiros
                </vs-td>
                <vs-td colspan="7" class="text-center bold">
                  Retiros
                </vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td class="text-center">C210</vs-td>
                <vs-td class="text-left">Retiro a cuenta bancaria nacional %banks.name% cuenta %bank_accounts.account%
                </vs-td>
                <vs-td class="text-right">{{ getAmount('C210') }}</vs-td>
                <vs-td></vs-td>
                <vs-td class="text-right">{{ getAmount('I210') }}</vs-td>
                <vs-td class="text-left">Retiro a cuenta bancaria nacional %banks.name% cuenta %bank_accounts.account%
                </vs-td>
                <vs-td class="text-center">I210</vs-td>
              </vs-tr>
              <!-- End Inversión en Proyectos - Retiros -->
              </tbody>
            </vs-table>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import {es} from "vuejs-datepicker/dist/locale";

export default {
  name: 'TransactionsMonitor',
  components: {
    Datepicker
  },
  data() {
    return {
      trxList: null,
      filterType: 1,
      totals: {},
      date: moment().subtract(1, 'day').format(),
      es: es,
      numberFormat: new Intl.NumberFormat('en-MX', {
        style: 'decimal',
        currency: 'MXN',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    }
  },
  async mounted() {
    await this.handleSearch();
  },
  methods: {
    getAmount(trxType) {
      if (this.trxList[trxType] != null)
        return this.numberFormat.format(this.trxList[trxType].amount);
      return 'N/A';
    },
    getSum(categoryType, ...trxTypesList) {
      let total = 0;
      for (const trxType of trxTypesList) {
        const trx = this.trxList[trxType];
        if (trx)
          total += trx.amount;
      }

      this.totals[categoryType] = total;
      return this.numberFormat.format(total);
    },
    getDifference(type1, type2) {
      return this.numberFormat.format(this.totals[type1] - this.totals[type2]);
    },
    isGreaterThanZero(type1, type2) {
      return (this.totals[type1] - this.totals[type2]) != 0;
    },
    async handleSearch() {
      try {
        this.showLoading(true);
        const {data} = await axios.post('api/v1/trx', {
          date: this.date,
          filterType: this.filterType
        });
        if (data.success) {
          this.trxList = data.message;
          this.showLoading(false);
          return;
        }
        this.errorNotif('Error en la operación', data.message);
      } catch (error) {
        console.log(error);
        this.errorNotif('Error en la operación', error);
      }
      this.showLoading(false);
    },
  },
  computed: {
    disabledDates() {
      return {
        from: new Date()
      }
    }
  },
}
</script>

<style lang="css">
.bg-gray {
  background-color: rgb(235, 235, 235);
  margin: 5px;
  padding: 5px;
}

.capitalize::first-letter {
  text-transform: capitalize;
}
</style>
